<template>
  <section class="px-8">
    <div class="flex justify-between mb-2">
      <h2 class="text-2xl font-bold px-3 py-3">Wardrobe</h2>
      <button
        @click="openCreateModal"
        class="bg-gray-400 text-white font-bold py-2 px-4 rounded"> + Add
      </button>
    </div>
      
      <div class="container flex justify-center items-center py-3"> 
        <el-tooltip content="Dress" placement="top" effect="light"><el-button>Spring</el-button></el-tooltip>
        <el-tooltip content="Tshirt" placement="bottom" effect="light"><el-button>Summer</el-button></el-tooltip>
        <el-tooltip content="Hoodie" placement="bottom" effect="light"><el-button>Fall</el-button></el-tooltip>
        <el-tooltip content="Sweater" placement="bottom" effect="light"><el-button>Winter</el-button></el-tooltip>
      </div>


    <div class="bg-gray-100 grid grid-cols-2 lg:grid-cols-4 gap-3 rounded-full">
      <div
        v-for="garment in garments"
        :key="garment.id"
        class="bg-white shadow-lg thumbnail"
      >
        <div class="relative">
          <div
            class="overlay absolute z-10 w-full h-full flex items-center justify-center"
          >
            <button @click="removeGarment(garment.id)" class="btn bg-red-300">
              Delete
            </button>
          </div>
          <img
            class="w-full"
            :src="garment.image"
            :alt="'Image of a' + garment.category"
          />
        </div>
        <div class="p-2 flex justify-between items-center">
          <h2 class="font-bold text-2xl text-gray-400">{{ garment.category }}</h2>
          <p class="font-bold">{{garment.color }}</p>
          <p class="font-bold">{{garment.seanson }}</p>
        </div>
      </div>
    </div>

    <!-- modal -->
    <main
      v-if="createModal"
      class="overflow-y absolute z-20 top-0 left-0 w-screen flex items-center justify-center pb-20"
    >
      <div class="bg-white p-8 rounded w-96">
        <div class="flex justify-between items-center mb-8">
          <h2 class="font-bold text-4xl">Add Garment</h2>
          <button @click="createModal = false" class="font-bold text-3xl">
            x
          </button>
        </div>

        <el-form label-position="top" label-width="100px" :model="form">
          <el-form-item label="Category">
            <el-input v-model="form.category"></el-input>
          </el-form-item>

          <el-form-item label="Color">
            <el-input v-model="form.color"></el-input>
          </el-form-item>

          <el-form-item label="Season">
            <el-input type="textarea" v-model="form.season"></el-input>
          </el-form-item>

          <el-form-item label="Texture">
            <el-input type="textarea" v-model="form.texture"></el-input>
          </el-form-item>

          <upload-image
            :description="'Choose the photo of your selected garment.'"
            cropOptions="3:2"
            label="Image of Garment"
            required="true"
            v-model="form.image"
            class="mr-2"
          />
          <div class="flex justify-center items-center mt-5">
          <button @click="storeGarment()" class="bg-pink-300 px-4 py-2 rounded-full mt-2 text-white">Create</button>

          </div>
        </el-form>
      </div>
    </main>
  </section>
</template>
<script>

import { db } from "@/db";
import UploadImage from "@/components/UploadImage.vue";

export default {
  data: function () {
    return {
      form: {
        category: "suit",
        color: "brown",
        season: "fall",
        texture: "cloth",
        image: null,
      },
      createModal: false,
      garments: [],
    };
  },
  components: {
    UploadImage,
  },
  methods: {
    // create
    openCreateModal() {
      this.form.category = null;
      this.form.color = null;
      this.form.season = null;
      this.form.texture = null;
      this.form.image = null;
      // open the modal
      this.createModal = true;
    },
    // store
    storeGarment() {
      // store in firebase
      db.collection("Garment").add({
        category: this.form.category,
        color: this.form.color,
        season: this.form.season,
        texture: this.form.texture,
        image: this.form.image,
      });
      // close the modal
      this.createModal = false;
    },
    // edit
    // update
    // delete
    removeGarment(id) {
      db.collection("Garment").doc(id).delete();
    },
  },
  firestore: {
    garments: db.collection("Garment"),
  },
};
</script>
<style scoped>
.thumbnail .overlay {
  opacity: 0;
}

.thumbnail:hover .overlay {
  opacity: 1;
}
.h2{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-left: 40px;
}
</style>